import db from "../driverappdb";

export const BufferSlotRepository = {
    getBufferSlots: async (routeId) => {
        return await db.bufferslots.where({ routeId: routeId }).with({ location: 'locationId' });
    }
};